export default {
    state:{
        movieListSearch:{
            page:1,
            data:[],
            querry:{
                status:{cinerama:'none'},
                selectedJanres:[],
                showedJanres:[],
                showedCountries:[],
                countries:[],
                genres:[],
                isAllJaner:true,
                isAllCountry:true,
                isAllYear:true,
                showAllJanres:false,
                showAllCounties:false,
                showAllYears:false,
                showedYears:[],
                years:[],
                types:[],
            }
        }
    },
    actions:{},
    mutations:{
        updateMovieListSearch(state,content){
            state.movieListSearch = content
        }
    },
    getters:{
        getMovieListSearch(state){
            return state.movieListSearch
        }
    },
}